var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCipherByNaluriLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2576,
    height: 1109,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 792,
    y: 637,
    width: 2576,
    height: 1109
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2316,
    y: 1207,
    width: 977,
    height: 489
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2316,
    y: 1207,
    width: 977,
    height: 489
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2316,
    y: 1207,
    width: 977,
    height: 489
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-792 -637)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.3 266.223C141.3 234.527 165.369 206.975 197.24 206.975 229.111 206.975 253.179 234.527 253.179 266.223L253.179 332.857C253.179 335.957 250.671 338.465 247.571 338.465L230.783 338.465C227.683 338.465 225.175 335.957 225.175 332.857L225.175 266.223C225.175 247.937 211.66 234.945 197.205 234.945 182.75 234.945 169.235 247.937 169.235 266.223L169.235 332.857C169.235 335.957 166.727 338.465 163.627 338.465L146.838 338.465C143.738 338.465 141.23 335.957 141.23 332.857L141.23 266.223 141.3 266.223Z",
    fill: "#0F7A99",
    fillRule: "evenodd",
    fillOpacity: 1,
    transform: "matrix(1.00103 0 0 1 2317 1208)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.509 266.209C605.509 234.52 629.572 206.975 661.434 206.975L674.006 206.975C677.105 206.975 679.611 209.482 679.611 212.581L679.611 229.366C679.611 232.465 677.105 234.972 674.006 234.972L661.434 234.972C646.948 234.972 633.473 247.961 633.473 266.243L633.473 332.86C633.473 335.957 630.965 338.465 627.865 338.465L611.08 338.465C607.981 338.465 605.475 335.957 605.475 332.86L605.475 266.243 605.509 266.209Z",
    fill: "#0F7A99",
    fillRule: "evenodd",
    fillOpacity: 1,
    transform: "matrix(1.00103 0 0 1 2317 1208)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.352 279.217C585.352 310.913 561.282 338.465 529.413 338.465 497.541 338.465 473.471 310.913 473.471 279.217L473.471 212.583C473.471 209.483 475.979 206.975 479.079 206.975L495.868 206.975C498.968 206.975 501.476 209.483 501.476 212.583L501.476 279.217C501.476 297.503 514.99 310.494 529.447 310.494 543.901 310.494 557.418 297.503 557.418 279.217L557.418 212.583C557.418 209.483 559.923 206.975 563.026 206.975L579.813 206.975C582.915 206.975 585.42 209.483 585.42 212.583L585.42 279.217 585.352 279.217Z",
    fill: "#0F7A99",
    fillRule: "evenodd",
    fillOpacity: 1,
    transform: "matrix(1.00103 0 0 1 2317 1208)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.3 272.72C301.3 251.862 318.189 234.972 339.047 234.972 359.908 234.972 376.794 251.862 376.794 272.72 376.794 274.636 376.656 276.516 376.378 278.362 375.82 279.231 375.506 280.276 375.506 281.391L375.506 282.609C371.155 298.663 356.494 310.502 339.047 310.502 318.189 310.502 301.3 293.615 301.3 272.754L301.3 272.72ZM375.506 327.427C365.06 334.391 352.525 338.465 339.047 338.465 302.763 338.465 273.302 309.041 273.302 272.72 273.302 236.4 302.727 206.975 339.047 206.975 375.367 206.975 404.792 236.4 404.792 272.72 404.792 275.644 404.619 278.501 404.237 281.32L404.237 332.86C404.237 335.957 401.729 338.465 398.629 338.465L381.114 338.465C378.014 338.465 375.506 335.957 375.506 332.86L375.506 327.427Z",
    fill: "#0F7A99",
    fillRule: "evenodd",
    fillOpacity: 1,
    transform: "matrix(1.00103 0 0 1 2317 1208)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.729 338.465C702.563 338.465 700.002 335.903 700.002 332.738L700.002 212.703C700.002 209.536 702.563 206.975 705.729 206.975L722.876 206.975C726.042 206.975 728.603 209.536 728.603 212.703L728.603 332.701C728.603 335.867 726.042 338.429 722.876 338.429L705.729 338.429 705.729 338.465Z",
    fill: "#0F7A99",
    fillRule: "evenodd",
    fillOpacity: 1,
    transform: "matrix(1.00103 0 0 1 2317 1208)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.693 338.465C427.457 338.465 424.842 335.972 424.842 332.886L424.842 149.243C424.842 146.159 427.457 143.665 430.693 143.665L448.211 143.665C451.444 143.665 454.062 146.159 454.062 149.243L454.062 332.886C454.062 335.972 451.444 338.465 448.211 338.465L430.693 338.465Z",
    fill: "#0F7A99",
    fillRule: "evenodd",
    fillOpacity: 1,
    transform: "matrix(1.00103 0 0 1 2317 1208)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.148 186.141C831.148 186.141 831.148 185.919 831.148 185.844 831.148 162.562 812.625 143.698 789.753 143.698 766.884 143.698 748.358 162.562 748.358 185.844L748.358 186.141 748.358 225.057C748.358 233.932 755.43 241.098 764.123 241.098L815.387 241.098C824.116 241.098 831.148 233.894 831.148 225.057L831.148 186.141Z",
    fill: "#29B8CC",
    fillRule: "evenodd",
    fillOpacity: 1,
    transform: "matrix(1.00103 0 0 1 2317 1208)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M809.786 184.483 809.779 184.494 809.772 184.505C807.831 187.114 800.687 193.277 789.753 193.277 778.828 193.277 771.683 187.119 769.74 184.508 768.335 182.603 765.593 182.152 763.67 183.642 761.751 185.089 761.415 187.848 762.81 189.742 766.063 194.156 775.643 202.031 789.753 202.031 803.862 202.031 813.395 194.164 816.687 189.76 818.165 187.822 817.722 185.062 815.84 183.642 813.896 182.137 811.213 182.627 809.786 184.483Z",
    fill: "#0F7A99",
    fillRule: "evenodd",
    fillOpacity: 1,
    transform: "matrix(1.00103 0 0 1 2317 1208)"
  })))), /*#__PURE__*/React.createElement("text", {
    fill: "#1A2233",
    fillOpacity: 1,
    fontFamily: "Inter,Inter_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 700,
    fontStretch: "normal",
    fontSize: 527,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    transform: "matrix(1 0 0 1 1111 1302)"
  }, "CIPHER", /*#__PURE__*/React.createElement("tspan", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Inter,Inter_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 110,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    x: 1167.3,
    y: 232
  }, "by")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCipherByNaluriLogo);
export default __webpack_public_path__ + "static/media/cipher-by-naluri-logo.b4ad41540d7a9711f5d906bb967905e1.svg";
export { ForwardRef as ReactComponent };